import { useUserLeagueInfo } from './useUserLeagueInfo'

export default useUserLeagueInfo
